// GeminiGenerateConfig.jsx
export default function GeminiGenerateConfig({ logic, onContinue }) {
  const isGenerated = Boolean(logic.emailBody);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 20,
        padding: "16px",
        background: "rgba(13, 27, 42, 0.7)",
        borderRadius: "12px",
        border: "1px solid rgba(0, 212, 255, 0.2)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(10px)",
        height: "100%",
      }}
    >
      {/* HEADER */}
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
          <span style={{ 
            fontSize: "20px", 
            background: "linear-gradient(135deg, #9333ea, #00d4ff)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
          }}>
            🟣
          </span>
          <h3 style={{ 
            margin: 0, 
            fontSize: "18px", 
            fontWeight: 700,
            color: "#ffffff",
            fontFamily: "'Raleway','Poppins', sans-serif",
          }}>
            Gemini - Generate Email
          </h3>
        </div>
        <p style={{ 
          marginTop: 6, 
          fontSize: "13px", 
          color: "rgba(255, 255, 255, 0.7)", 
          lineHeight: 1.4,
          fontFamily: "'Raleway','Poppins', sans-serif",
        }}>
          Uses Gemini AI to generate a professional email body from a subject.
        </p>
      </div>

      {/* STATUS */}
      <div
        style={{
          alignSelf: "flex-start",
          padding: "8px 16px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: 600,
          background: logic.loading 
            ? "rgba(255, 193, 7, 0.2)" 
            : isGenerated 
              ? "rgba(0, 255, 136, 0.2)" 
              : "rgba(0, 212, 255, 0.2)",
          color: logic.loading 
            ? "#ffc107" 
            : isGenerated 
              ? "#00ff88" 
              : "#00d4ff",
          border: logic.loading 
            ? "1px solid rgba(255, 193, 7, 0.3)" 
            : isGenerated 
              ? "1px solid rgba(0, 255, 136, 0.3)" 
              : "1px solid rgba(0, 212, 255, 0.3)",
          fontFamily: "'Raleway','Poppins', sans-serif",
          animation: logic.loading ? "pulse 1.5s ease-in-out infinite" : "none",
          position: "relative",
          overflow: "hidden"
        }}
      >
        {logic.loading
          ? "⚡ Generating email…"
          : isGenerated
          ? "✓ Generated"
          : "● Idle"}
      </div>

      {/* FORM */}
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {/* TO */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <label style={{ 
            fontSize: "14px", 
            fontWeight: 600, 
            textAlign: "left",
            color: "#00d4ff",
            fontFamily: "'Raleway','Poppins', sans-serif",
          }}>
            Recipient Email (To)
          </label>
          <input
            placeholder="example@company.com"
            value={logic.toEmail}
            onChange={(e) => logic.setToEmail(e.target.value)}
            style={inputStyle}
          />
        </div>

        {/* SUBJECT */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <label style={{ 
            fontSize: "14px", 
            fontWeight: 600, 
            textAlign: "left",
            color: "#00d4ff",
            fontFamily: "'Raleway','Poppins', sans-serif",
          }}>
            Email Subject
          </label>
          <input
            placeholder="Follow-up on our discussion"
            value={logic.subject}
            onChange={(e) => logic.setSubject(e.target.value)}
            style={inputStyle}
          />
          <small style={{ 
            fontSize: "12px", 
            color: "rgba(255, 255, 255, 0.5)",
            fontFamily: "'Raleway','Poppins', sans-serif",
          }}>
            This subject will be sent to Gemini AI.
          </small>
        </div>
      </div>

      {/* ACTIONS */}
      <div style={{ display: "flex", gap: 12, marginTop: "auto" }}>
        <button
          onClick={logic.handleGenerate}
          disabled={logic.loading || !logic.subject || !logic.toEmail}
          style={primaryBtn(
            logic.loading || !logic.subject || !logic.toEmail
          )}
        >
          <span style={{ fontSize: "16px", marginRight: "8px" }}>⚡</span>
          {logic.loading ? "Generating…" : "Generate Email"}
        </button>

        <button
          onClick={onContinue}
          disabled={!isGenerated}
          style={secondaryBtn(!isGenerated)}
        >
          Review Email <span style={{ marginLeft: "6px" }}>→</span>
        </button>
      </div>
    </div>
  );
}

/* ---------- styles ---------- */

const inputStyle = {
  padding: "12px 16px",
  borderRadius: "10px",
  border: "1px solid rgba(0, 212, 255, 0.3)",
  fontSize: "14px",
  outline: "none",
  background: "rgba(0, 0, 0, 0.3)",
  color: "#ffffff",
  fontFamily: "'Raleway','Poppins', sans-serif",
  transition: "all 0.3s ease",
};

const inputStyleFocus = {
  borderColor: "#00d4ff",
  boxShadow: "0 0 15px rgba(0, 212, 255, 0.3)",
};

const primaryBtn = (disabled) => ({
  flex: 1,
  padding: "14px 16px",
  borderRadius: "12px",
  border: "none",
  background: disabled 
    ? "rgba(147, 51, 234, 0.3)" 
    : "linear-gradient(90deg, #9333ea 0%, #00d4ff 100%)",
  color: disabled ? "rgba(255, 255, 255, 0.5)" : "#000",
  fontSize: "14px",
  fontWeight: 600,
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.6 : 1,
  fontFamily: "'Raleway','Poppins', sans-serif",
  transition: "all 0.3s ease",
  position: "relative",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const primaryBtnHover = {
  transform: "translateY(-2px)",
  boxShadow: "0 0 25px rgba(147, 51, 234, 0.6)",
};

const secondaryBtn = (disabled) => ({
  flex: 1,
  padding: "14px 16px",
  borderRadius: "12px",
  border: "1px solid rgba(0, 212, 255, 0.4)",
  background: "rgba(0, 212, 255, 0.1)",
  color: disabled ? "rgba(0, 212, 255, 0.4)" : "#00d4ff",
  fontSize: "14px",
  fontWeight: 600,
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.5 : 1,
  fontFamily: "'Raleway','Poppins', sans-serif",
  transition: "all 0.3s ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const secondaryBtnHover = {
  background: "rgba(0, 212, 255, 0.2)",
  borderColor: "#00d4ff",
  transform: "translateY(-2px)",
};

// Add hover effects via JavaScript
if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    const inputs = document.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        Object.assign(input.style, inputStyleFocus);
      });
      input.addEventListener('blur', () => {
        Object.assign(input.style, inputStyle);
      });
    });
  });
}